import { RecipesSection } from "./RecipesSection";
import { ContainerImageSection } from "./ContainerImageSection";
import { Separator } from "@/components/ui/separator";
import { StartCommandAndPortSection } from "./StartCommandAndPortSection";
import { EnvironmentVariablesSection } from "./EnvironmentVariablesSection";
import { StandardContainer } from "@/components/Common/StandardContainer/StandardContainer";
import { HealthCheckSection } from "./HealthCheckSection";

type ConfigureContainerEnvironmentProps = {
  showRecipes?: boolean;
  /** User chose Custom Deployment from recipes-first; collapse stacks until expanded. */
  skippedRecipesFirst?: boolean;
};

export const ConfigureContainerEnvironment: React.FC<ConfigureContainerEnvironmentProps> = ({
  showRecipes = true,
  skippedRecipesFirst = false
}) => {
  return (
    <div className="flex flex-1 flex-col gap-6 _pb-10 max-lg:w-full _lg:max-w-[600px]">
      {showRecipes && (
        <>
          <StandardContainer>
            <RecipesSection skippedRecipesFirst={skippedRecipesFirst} />
          </StandardContainer>
          <Separator className="bg-gray-dark-200 dark:bg-gray-light-1900" />
        </>
      )}
      <StandardContainer>
        <ContainerImageSection />
      </StandardContainer>
      <Separator />
      <StandardContainer>
        <StartCommandAndPortSection />
      </StandardContainer>
      <Separator />
      <StandardContainer>
        <HealthCheckSection />
      </StandardContainer>
      <Separator />
      <StandardContainer>
        <EnvironmentVariablesSection />
      </StandardContainer>
    </div>
  );
};
